import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-246b525c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "alpha" }
const _hoisted_2 = { class: "alpha-checkboard-wrap" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "alpha-picker" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]

import { computed, onUnmounted, PropType, ref } from 'vue'

import Checkboard from './Checkboard.vue'
import { ColorFormats } from 'tinycolor2'


export default /*#__PURE__*/_defineComponent({
  __name: 'Alpha',
  props: {
  value: {
    type: Object as PropType<ColorFormats.RGBA>,
    required: true,
  },
},
  emits: ["colorChange"],
  setup(__props, { emit }: { emit: ({
  (event: 'colorChange', payload: ColorFormats.RGBA): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const color = computed(() => props.value)
    
const gradientColor = computed(() => {
  const rgbaStr = [color.value.r, color.value.g, color.value.b].join(',')
  return `linear-gradient(to right, rgba(${rgbaStr}, 0) 0%, rgba(${rgbaStr}, 1) 100%)`
})

const alphaRef = ref<HTMLElement>()
const handleChange = (e: MouseEvent) => {
  e.preventDefault()
  if (!alphaRef.value) return
  const containerWidth = alphaRef.value.clientWidth
  const xOffset = alphaRef.value.getBoundingClientRect().left + window.pageXOffset
  const left = e.pageX - xOffset
  let a

  if (left < 0) a = 0
  else if (left > containerWidth) a = 1
  else a = Math.round(left * 100 / containerWidth) / 100

  if (color.value.a !== a) {
    emit('colorChange', {
      r: color.value.r,
      g: color.value.g,
      b: color.value.b,
      a: a,
    })
  }
}

const unbindEventListeners = () => {
  window.removeEventListener('mousemove', handleChange)
  window.removeEventListener('mouseup', unbindEventListeners)
}
const handleMouseDown = (e: MouseEvent) => {
  handleChange(e)
  window.addEventListener('mousemove', handleChange)
  window.addEventListener('mouseup', unbindEventListeners)
}
onUnmounted(unbindEventListeners)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(Checkboard)
    ]),
    _createElementVNode("div", {
      class: "alpha-gradient",
      style: _normalizeStyle({ background: _unref(gradientColor) })
    }, null, 4),
    _createElementVNode("div", {
      class: "alpha-container",
      ref_key: "alphaRef",
      ref: alphaRef,
      onMousedown: _cache[0] || (_cache[0] = $event => handleMouseDown($event))
    }, [
      _createElementVNode("div", {
        class: "alpha-pointer",
        style: _normalizeStyle({ left: _unref(color).a * 100 + '%' })
      }, _hoisted_4, 4)
    ], 544)
  ]))
}
}

})